import React from "react";
import type { PageManagerContextState } from "./PageManager.provider";

export const PageManagerContext =
	React.createContext<PageManagerContextState>(null);
